// @ts-nocheck
import React, { createContext, useContext, useState, useCallback } from 'react';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import { Button } from '@mui/material';
import * as PXBColors from '@brightlayer-ui/colors';
import { useLanguageLocale } from '../hooks/language-locale-hooks';

const SnackbarContext = createContext({
    success: (message: any) => { },
    warning: (message: any) => { },
    error: (message: any) => { }
});

export const useSnackbar = () => {
    return useContext(SnackbarContext);
};

export const SnackbarProvider = ({ children }) => {
    const { t } = useLanguageLocale();

    const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success', background: PXBColors.black[900], color: PXBColors.black[900] });

    const showSnackbar = useCallback((message: any, severity: any, background: any, color: any = PXBColors.black[900]) => {
        setSnackbar({ open: true, message, severity, background });
    }, []);

    const hideSnackbar = useCallback(() => {
        setSnackbar({ open: false, message: '', severity: 'success' });
    }, []);

    const success = (message: any) => showSnackbar(message, 'success', PXBColors.black[900]);
    const warning = (message: any) => showSnackbar(message, 'warning', PXBColors.yellow[500], PXBColors.black[900]);
    const error = (message: any) => showSnackbar(message, 'error', PXBColors.red[500]);

    return (
        <SnackbarContext.Provider value={{ success, warning, error }}>
            {children}
            <Snackbar
                open={snackbar.open}
                onClose={hideSnackbar}
                autoHideDuration={5000}
                message={snackbar.message}
                action={
                    <Button size="small" onClick={hideSnackbar}>
                        {t('ACTIONS.OKAY')}
                    </Button>
                }
                ContentProps={{ sx: { background: snackbar.background, color: snackbar.color } }}
                anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                sx={{ bottom: { xs: 90, sm: 0 } }}
                style={{ width: 'auto', bottom: 24, flexGrow: 0 }}
            />
        </SnackbarContext.Provider>
    );
};
